<div class="w-100 d-flex justify-content-center mb-2">
    <button class="btn btn-outline-secondary rounded-0 me-3 mt-4 mb-2" type="button"
        (click)="setAqManualControlImageOff()">
        Bild aus</button>

    <button
        [disabled]="selectedAqChannel === undefined  || selectedAQControlStellcode === 0"
        class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2" type="button" (click)="createAqControl()">
        Steuerung erstellen</button>
    <button [disabled]="selectedAqChannel === undefined" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="turnAqControlOff()">
        Steuerung entfernen</button>

</div>